module.exports = __webpack_public_path__ + "img/doctor.3a50e8dc.png";